import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { DownloadApp } from './download-app'

@Injectable()
export class DownloadAppService {
  constructor(private dialog: MatDialog) {}

  open() {
    const defaultConfig: MatDialogConfig = {
      width: '600px',
      height: 'auto',
      panelClass: ['fixed-modal', 'no-scroll-modal'],
    }

    return this.dialog.open(DownloadApp, defaultConfig)
  }
}
